import { Component, OnInit } from '@angular/core';
import { MainService } from '../../../_services/main.service';

@Component({
  selector: 'app-product-returns',
  templateUrl: './product-returns.component.html',
  styleUrls: ['./product-returns.component.scss']
})
export class ProductReturnsComponent implements OnInit {

  constructor(public mainService: MainService) { }

  ngOnInit() {
  }

}
